import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { applicationState } from 'shared/store/applicationState'
import { formatDateTime, toISOLocalDate } from "shared/models/mapping/mapping";
import { Toggle } from "components/ui/ToggleContent";
import { PageList } from "components/ui/PageList";
import { Chip } from "@mui/material";
import { FilterArrow } from 'components/portal/GridComponents';
import { ToggleButton } from 'components/ui/ToggleButton';

import {
    ChevronRight as LinkIcon,
    ArrowDownward as SortDescIcon,
    ArrowUpward as SortAscIcon,
    ImportExport as SortNoneIcon,
    NearMeOutlined,
    SupervisorAccountOutlined
} from '@mui/icons-material';
import { TrainView } from './TrainEventRecordView';
import { getAdminTrainEventList, getUserTrainEventList } from '../../../../shared/services/TrainEventRecordApi';
import { ISelectOption } from '../../forms/util';
import { trainEventAdminSummaryDashboardOverview, trainEventUsersSubmittedFormList } from './TrainEventRecordPageSelector';
import { TrainEventRecordList } from '../../../../shared/models/api/models';
import { trainEventAdminOverviewPathRoute, trainEventUsersSubmittedFormListRoute } from '../OperationalFormsRoutes';
import { OperationalFormsPage } from '../OperationalFormsPage';


enum OrderByOption {
    NameAsc,
    NameDesc,
    StartTimeAsc,
    StartTimeDesc
}

interface TitleProps {
    title: string
}

const TitleContainer = (props: TitleProps) => {
    return (
        <div className="fa-list-title">
            <div className="fa-list-title-text">{props.title}</div>
        </div>
    );
}


interface IPageSizeDropdownProps {
    pageSize: number,
    setPageSize: (pageSize: number) => void,
    defaultExpanded?: boolean,
    sizes: number[]
}

const PageSizeDropdown = (props: IPageSizeDropdownProps) => {
    return (
        <span className="psl-list-container">
            <div className="psl-list">
                {props.sizes.map(s =>
                    <div key={s}
                        className={`psl-item${s === props.pageSize ? " selected" : ""}`}
                        onClick={() => props.setPageSize(s)}>{s} items</div>
                )}
            </div>
        </span>
    );
}

const PageSizeWithPicker = (props: IPageSizeDropdownProps) => {
    return (
        <Toggle label={props.pageSize + " items"} collapseOnChangeOf={props.pageSize}>
            <PageSizeDropdown {...props} />
        </Toggle>
    );
};


interface ResultCountProps {
    viewCount: number,
    resultCount: number,
    pageSize: number,
    setPageSize: any,
    link?: string,
    visible?: boolean
}

const ResultCountContainer = (props: ResultCountProps) => {

    if (!props.visible) {
        return (<></>);
    }

    return (
        <div className="fa-list-resultcount float-right">
            {props.link &&
                <Link to={props.link} className="fa-list-resultcount-link">
                    <span className="fa-list-resultcount-text">{props.viewCount} of {props.resultCount} results</span>
                    <LinkIcon />
                </Link>
            }
            {!props.link &&
                <div className="fa-list-resultcount-itemsPerPage">
                    <span className="picker">
                        <PageSizeWithPicker
                            pageSize={props.pageSize}
                            setPageSize={props.setPageSize}
                            sizes={[10, 25, 50, 100]} />
                    </span>
                    <span> per page of {props.resultCount} results</span>
                </div>
            }
        </div>
    );
}

interface TeListProps {
    loading: boolean,
    adminView?: boolean,
    currentView: TrainView,
    assessments: TrainEventRecordList[],
    pageNumber: number,
    pageSize: number,
    orderByOption: OrderByOption,
    orderByName: any,
    orderByStartDateTime: any,
    orderByStatus: any
}

const TrainEventListContainer = (props: TeListProps) => {
    const [displayAssessments, setDisplayAssessments] = useState(props.assessments.slice(0, props.pageSize));
    const [formOptions, setFormOptions] = useState([] as string[]);

    const navigate = useNavigate();

    const nameOrderIcon = () => {
        if (props.orderByOption === OrderByOption.NameAsc) {
            return (<SortDescIcon />);
        }
        else if (props.orderByOption === OrderByOption.NameDesc) {
            return (<SortAscIcon />);
        }
        return (<SortNoneIcon />);
    }

    const startTimeOrderIcon = () => {
        if (props.orderByOption === OrderByOption.StartTimeAsc) {
            return (<SortDescIcon />);
        }
        else if (props.orderByOption === OrderByOption.StartTimeDesc) {
            return (<SortAscIcon />);
        }
        return (<SortNoneIcon />);
    }

    useEffect(() => {
        let start = (props.pageNumber - 1) * props.pageSize;

        let newDisplayAssessments = props.assessments.slice(start, start + props.pageSize);

        setDisplayAssessments(newDisplayAssessments);
    }, [props.assessments, props.pageNumber, props.pageSize]);

    return (
        <div className="fa-list-body">
            {props.loading === true ?
                <div className="p-4 text-center">Loading...</div>
                :
                <>
                    <div className="row assessment-card-row">
                        <div className="de-col de-col-medium" onClick={props.orderByName}>Name {nameOrderIcon()}</div>
                        <div className="de-col de-col-date" onClick={props.orderByStartDateTime} >Event Date {startTimeOrderIcon()}</div>

                        <div className="de-col de-col-narrow" onClick={props.orderByStatus}>Leader Active {nameOrderIcon()}</div>

                        <div className="de-col de-col-wide" >Supervisor</div>

                        <div className="de-col de-col-narrow">DurationOfDelay</div>
                        <div className="de-col de-col-on-behalf">IsLoaded</div>
                        <div className="de-col de-col-medium">DriversDepot</div>
                    </div>
                    <div className="fatigue-assessment-divider row"></div>
                    {(displayAssessments !== undefined && displayAssessments.length > 0) ? displayAssessments.map((user, id) => (
                        <>
                            <div className="row align-items-center assessment-card assessment-card-row" style={{ cursor: 'pointer' }} >
                               
                                <div className="de-col de-col-medium"> {user.driversName.fullname} </div>
                                <div className="de-col de-col-date">{formatDateTime(user.eventDate)}</div>

                                <div className="de-col de-col-narrow" > {(user.leaderActive ? "True" : "")} </div>
                                <div className="de-col de-col-wide">{user.supervisor.fullname}</div>
                                <div className="de-col de-col-narrow" > {user.durationOfDelay} </div>
                                <div className="de-col de-col-on-behalf">{(user.isLoaded ? "True" : "")}</div>
                                <div className="de-col de-col-medium">{user.driversDepotName}</div>
                               
                            </div>

                        </>

                    ))
                        :
                        <div>
                            <div >
                                <div className="p-4 text-center">There are no TrainEvent Record to display.</div>
                            </div>
                        </div>
                    }
                </>
            }
        </div>
    );
}


interface FooterProps {
    pageNumber: number,
    pageSize: number,
    totalResults: number,
    moveToPage: any,
    visible?: boolean
}

const FooterContainer = (props: FooterProps) => {

    if (!props.visible) {
        return (<></>);
    }

    return (
        <div className="fa-list-footer">
            <div className="page-list">
                <PageList {...props} />
            </div>
        </div>
    );
}

interface TeDashboardProps {
    page: ISelectOption,
    pageView: TrainView,
    showPageSize?: boolean,
    showHeaderLink?: boolean,
    showFilters?: boolean,
    showFooter?: boolean
}
const TrainEventRecordDashboard = (props: TeDashboardProps) => {
    const [selectedPage] = useState(props.page ?? trainEventUsersSubmittedFormList);
    const [pageView] = useState(props.pageView ?? TrainView.MyForm);
    const [currentView, setCurrentView] = useState(props.pageView);
    const [assessmentCacheTime, setAssessmentCacheTime] = useState(new Date().getTime());
    const [assessments, setAssessments] = useState(undefined as TrainEventRecordList[] | undefined);
    const [viewAssessments, setViewAssessments] = useState([] as TrainEventRecordList[]);
    const [loading, setLoading] = useState(true);
    const [pageSize, setPageSize] = useState(25);
    const [pageNumber, setPageNumber] = useState(1);
    const [headerLink, setHeaderLink] = useState(undefined as string | undefined);
    const [adminView, setAdminView] = useState(false);
    const [orderByOption, setOrderByOption] = useState(OrderByOption.StartTimeAsc);
    const [loadBackground, setLoadBackground] = useState(false);

    const dateTimeFormat = new Intl.DateTimeFormat("en-AU", {});

    const getPageTitle = () => {
        var title = selectedPage.label;
        return title;
    }

    const pageTitle = getPageTitle();

    const getViewData = async () => {
        setAssessmentCacheTime(new Date().getTime());
        let items: TrainEventRecordList[] = [];

        if (currentView === TrainView.MyForm) {
            items = await getUserTrainEventList();
            setAdminView(false);
            setAssessmentCacheTime(new Date().getTime());
            return items;
        }
        else if (currentView === TrainView.Overview) {
            items = await getAdminTrainEventList();
            setAdminView(true);
            setAssessmentCacheTime(new Date().getTime());
            return items;
        }
        setAssessmentCacheTime(new Date().getTime());
        return items;
    }

    const orderByName = () => {
        let data: TrainEventRecordList[] = assessments ? [...assessments] : [];

        data.sort((a, b) => {
            let aName = a.driversName?.fullname || "";
            let bName = b.driversName?.fullname || "";
            return aName.localeCompare(bName);
        }
        );

        let sortBy = OrderByOption.NameAsc;
        if (orderByOption == OrderByOption.NameAsc) {
            sortBy = OrderByOption.NameDesc;
            data.reverse();
        }
        setOrderByOption(sortBy);
        setViewAssessments(data);
    }
    const orderByStatus = () => {
        let data: TrainEventRecordList[] = assessments ? [...assessments] : [];

        let sortBy = OrderByOption.NameAsc;
        if (orderByOption == OrderByOption.NameAsc) {
            sortBy = OrderByOption.NameDesc;
            data.reverse();
        }
        setOrderByOption(sortBy);
        setViewAssessments(data);
    }

    const orderByEventDateTime = () => {
        let data: TrainEventRecordList[] = assessments ? [...assessments] : [];

        data.sort((a, b) => {
            let aTime = a.eventDate || Date.now;
            let bTime = b.eventDate || Date.now;
            if (aTime < bTime) return -1;
            if (aTime > bTime) return 1;
            return 0;
        }
        );

        let sortBy = OrderByOption.StartTimeAsc;
        if (orderByOption == OrderByOption.StartTimeAsc) {
            sortBy = OrderByOption.StartTimeDesc;
            data.reverse();
        }

        setOrderByOption(sortBy);
        setViewAssessments(data);
    }

    const configHeaderLink = () => {
        if (!props.showHeaderLink) {
            return;
        }

        let link = undefined as string | string[] | undefined

        if (currentView === TrainView.MyForm) {
            link = trainEventUsersSubmittedFormListRoute.path;
        }
        else if (currentView === TrainView.Overview) {
            link = trainEventAdminOverviewPathRoute.path;
        }

        if (typeof (link) === 'string') {
            setHeaderLink(link);
        }

    }

    const moveToPage = (page: number) => {
        setPageNumber(page);
    }

    const updateCurrentView = (view: TrainView) => {
        setAssessments(undefined);
        setCurrentView(view);
    }

    useEffect(() => {
        let mounted = true;
        const mount = async () => {
            setLoading(true);
            const items = await getViewData();
            configHeaderLink();

            if (mounted && Array.isArray(items)) {
                setAssessments(items);
                setViewAssessments(items);
                setLoading(false);
            }
        };

        if (!assessments) {
            mount();
        }

        return () => { mounted = false; };
    }, [currentView, viewAssessments]);

    useEffect(() => {
        let mounted = true;
        const mount = async () => {
            const items = await getViewData();
            if (mounted && Array.isArray(items)) {
                setAssessments(items);
                setViewAssessments(items);
            }
            setLoadBackground(false);
        }

        if (loadBackground) {
            mount();
        }

        return () => { mounted = false; };
    }, [loadBackground]);

    useEffect(() => {
        const pollingSeconds = 60;
        const cacheAgeThreshold = 50;
        const interval = setInterval(() => {
            if (currentView !== TrainView.MyForm && assessmentCacheTime < new Date().getTime() - (cacheAgeThreshold * 1000)) {
                setLoadBackground(true);
            }
        }, pollingSeconds * 1000);
        return () => {
            clearInterval(interval);
        }
    }, []);

    return (
        <>
                    <ResultCountContainer
                        viewCount={viewAssessments.length}
                        resultCount={viewAssessments.length}
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                        link={headerLink}
                        visible={true} />


                    <TrainEventListContainer
                        loading={loading}
                        assessments={viewAssessments}
                        adminView={adminView}
                        currentView={currentView}
                        pageNumber={pageNumber}
                        pageSize={pageSize}
                        orderByOption={orderByOption}
                        orderByName={orderByName}
                        orderByStartDateTime={orderByEventDateTime}
                        orderByStatus={orderByStatus}
                    />

                    <FooterContainer
                        visible={true}
                        pageNumber={pageNumber}
                        pageSize={pageSize}
                        totalResults={viewAssessments.length}
                        moveToPage={moveToPage}
                    />
        </>
    );
}

export default TrainEventRecordDashboard;
